import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageFooter, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function ImportPatientListTemplate({ listViewStore }) {
    const {
        rootStore,
        tableLoading,
        tableStore,
        queryUtility,
        importAll,
        isProcessing,
        needsConfirmation,
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                <BaasicButton
                    icon={isProcessing ? 'u-icon u-icon--med u-icon--sync u-rotate--login' : 'u-display--none'}
                    className='btn btn--base btn--primary u-mar--left--sml'
                    label={('Import All')}
                    onClick={() => importAll()}
                    disabled={isProcessing || needsConfirmation}
                    authorized={rootStore.permissionStore.hasPermission('portalSection.create')}
                />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}></TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='IMPORT_PATIENT.LIST.EMPTY_STATE.TITLE' description='IMPORT_PATIENT.LIST.EMPTY_STATE.DESCRIPTION' />
}
function renderActions({item, actions, authorization}){
    if (!isSome(actions)) return null;

    const { onEdit, onDelete, onPreview, onPatient } = actions;
    if (!isSome(onEdit) && !isSome(onPreview) && !isSome(onDelete) && !isSome(onPatient)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onPatient) && item.patientBtId != null ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--persons--dark u-icon--sml'
                        label='Patient'
                        onlyIcon={true}
                        onClick={() => onPatient(item)}>
                    </BaasicButton>
                ) : null} 
                {item.patientDetailId && item.patientDetailId.length > 0 ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='Preview'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='Edit'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='Delete'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null} 
            </div>
        </td>
    );

}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

ImportPatientListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(ImportPatientListTemplate);
